import React, { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FormGroup } from '@blueprintjs/core';
import Row from 'containers/Reports/row';
import { DatePicker } from '@blueprintjs/datetime';
import moment from 'moment';
import { runConditionalApprovalCommentsReport } from 'actions/reports';
import { getMaxDate } from 'utils/functions';

const dateCheckOptions = [
  { label: 'Before', value: 'BEFORE' },
  { label: 'On', value: 'ON' },
  { label: 'After', value: 'AFTER' },
];

const dateTypeOptions = [
  { label: 'Approval Date', value: 'approvalDate' },
  { label: 'Renewal Date', value: 'renewalDate' },
];

const ConditionalApprovalCommentsBase = ({
  runConditionalApprovalCommentsReport,
  report,
  ...rest
}) => {
  const [dateType, setDateType] = useState(dateTypeOptions[0]);
  const [dateCheck, setDateCheck] = useState(dateCheckOptions[0]);
  const [date, setDate] = useState(new Date());

  const handleChange = (selected, setter) => {
    setter(selected);
  };

  return (
    <Row
      name="Conditional Approval Comments"
      description='Assessments, including their override comment, that have the "Conditional Approval" status.'
      drawer={
        <div style={{ width: '50%' }}>
          <FormGroup label="Date Type">
            <Select
              options={dateTypeOptions}
              value={dateType}
              onChange={selected => handleChange(selected, setDateType)}
            />
          </FormGroup>
          <FormGroup label="Date Before, On, After">
            <Select
              options={dateCheckOptions}
              value={dateCheck}
              onChange={selected => handleChange(selected, setDateCheck)}
            />
          </FormGroup>
          <FormGroup label="Date">
            <DatePicker
              value={date}
              onChange={selected => handleChange(selected, setDate)}
              maxDate={getMaxDate()}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runConditionalApprovalCommentsReport({
          date: {
            dateType: dateType.value,
            date: moment(date).format('YYYY-MM-DD'),
            dateCheck: dateCheck.value,
          },
        })
      }
      data={report}
      headers={[
        { label: 'Assessment ID', key: 'vendorRequestID' },
        { label: 'Third Party Name', key: 'vendorName' },
        { label: 'Product / Service Name', key: 'productServiceName' },
        { label: 'Approval Date', key: 'approvalDate' },
        { label: 'Renewal Date', key: 'renewalDate' },
        { label: 'Conditional Approval Comments', key: 'overrideNote' },
        { label: 'Sponsor First Name', key: 'sponsorFirstName' },
        { label: 'Sponsor Last Name', key: 'sponsorLastName' },
        { label: 'Department', key: 'sponsorDepartment' },
        { label: 'Requesting Department(s)', key: 'departmentsRequesting' },
      ]}
      resetDrawerState={() => {
        setDateType(dateTypeOptions[0]);
        setDateCheck(dateCheckOptions[0]);
        setDate(new Date());
      }}
      {...rest}
    />
  );
};

const mapStateToProps = state => ({
  report: state.reports.conditionalApprovalComments,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
});

const ConditionalApprovalComments = connect(
  mapStateToProps,
  { runConditionalApprovalCommentsReport }
)(ConditionalApprovalCommentsBase);

export default ConditionalApprovalComments;
